import { getSuggestedQuestions } from 'api/v2/AI';
import classNames from 'classnames';
import { FC } from 'react';
import 'react-loading-skeleton/dist/skeleton.css';
import { useQuery } from 'react-query';
import { SuggestedQuestionUseCaseEnum } from 'types/ai.types';
import { AICacheKeys } from 'types/cacheKeys.types';
import AutoScrollingContainer from './AutoScrollingContainer';
import SuggestedQuestionCard from './SuggestedQuestionCard';
import SuggestedQuestionSkeleton from './SuggestedQuestionSkeleton';

const useSuggestedQuestions = (use_case: SuggestedQuestionUseCaseEnum) =>
  useQuery(
    [AICacheKeys.SuggestedQuestions, use_case],
    () => getSuggestedQuestions(use_case),
    { select: ({ data }) => data },
  );

type AISuggestedQuestionsProps = {
  use_case: SuggestedQuestionUseCaseEnum;
  horizontal?: boolean;
};

const AISuggestedQuestions: FC<AISuggestedQuestionsProps> = ({
  use_case,
  horizontal = false,
}) => {
  const { data: suggestedQuestions, isLoading } =
    useSuggestedQuestions(use_case);

  return (
    <AutoScrollingContainer
      speed={isLoading ? 0 : 16}
      className={classNames('pb-3', {
        'px-8': horizontal,
        'px-5': !horizontal,
      })}
    >
      {isLoading ? (
        <SuggestedQuestionSkeleton horizontal={horizontal} />
      ) : (
        suggestedQuestions?.map((q, index) => (
          <SuggestedQuestionCard
            question={q}
            key={q.id}
            horizontal={horizontal}
            index={index}
          />
        ))
      )}
    </AutoScrollingContainer>
  );
};

export default AISuggestedQuestions;
